module.exports = __webpack_public_path__ + "img/194.8719c2e7.jpg";